import t from "react";
import { useTranslation as m } from "react-i18next";
import { KioskHeaderImg as l } from "../../components/KioskHeaderImg/KioskHeaderImg.js";
import { KioskLanguageSelector as g } from "../../components/KioskLanguageSelector/KioskLanguageSelector.js";
import { KioskTitle as i } from "../../components/KioskTitle/KioskTitle.js";
import { useKioskLanding as c } from "../../context.js";
import r from "./languages.module.scss.js";
function v() {
  const { configuration: e, lang: s, back: n } = c(), { t: o } = m(), a = e == null ? void 0 : e.service.text[s];
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "languages" }, /* @__PURE__ */ t.createElement(l, null), /* @__PURE__ */ t.createElement("div", { className: r.languagesWrapper }, /* @__PURE__ */ t.createElement(i, { text: (a == null ? void 0 : a.choose_language) || o("kioskLanding.service.otherLanguages") }), /* @__PURE__ */ t.createElement("div", { className: r.languageSelectorContainer }, /* @__PURE__ */ t.createElement(
    g,
    {
      langs: (e == null ? void 0 : e.common.settings.supportedLanguages) ?? [],
      onChange: () => n()
    }
  ))));
}
export {
  v as Languages
};
//# sourceMappingURL=Languages.js.map
